/**
 * Version applicative affichée (footer de la sidebar), au format CalVer
 * `v<YY>.<M>.<patch>` — ex. `v26.8.0`.
 *
 * `next.config.ts` inline systématiquement `NEXT_PUBLIC_APP_VERSION` depuis la
 * version de `package.json`, que `scripts/release.js` bumpe à chaque release :
 * dans un build Next, la valeur est donc toujours définie. Le repli ne sert
 * qu'aux contextes sans configuration Next (typiquement Jest) — d'où `dev`, qui
 * signale l'absence d'information plutôt que d'afficher un numéro périmé.
 */
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';

/**
 * Numéro de build (façon mobile) affiché à côté de la version. Injecté par la CI
 * via `NEXT_PUBLIC_BUILD_NUMBER`, alimenté par `github.run_number` dans le job
 * `Build` ; `1` hors CI.
 */
export const APP_BUILD = process.env.NEXT_PUBLIC_BUILD_NUMBER || '1';

/** Libellé complet « version · build » pour le footer (ex. `v26.8.0 · build 42`). */
export const APP_VERSION_LABEL = APP_BUILD ? `${APP_VERSION} · build ${APP_BUILD}` : APP_VERSION;
